// extracted by mini-css-extract-plugin
export default {"text":"Menu_text__loTl6","label":"Menu_label__OmUY2","select":"Menu_select__BU3xs","menuItem":"Menu_menuItem__Ijl7-","iconRoot":"Menu_iconRoot__NoxOT","icon":"Menu_icon__PsyYe"};